import { render } from "./HeroOfficialBusinessStatus.vue?vue&type=template&id=62f8dd9e&scoped=true"
import script from "./HeroOfficialBusinessStatus.vue?vue&type=script&lang=js"
export * from "./HeroOfficialBusinessStatus.vue?vue&type=script&lang=js"

import "./HeroOfficialBusinessStatus.vue?vue&type=style&index=0&id=62f8dd9e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f8dd9e"]])

export default __exports__